/**
 * fromとtoで比較を行うコンポーネント
 */
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { observer } from "mobx-react";
import errMsgService from "../../services/common/errMsgService";
import stateStore from "../../store/stateStore";
// フォーカスの有無を判別するフラグメント
let isFocus = false;

// 受け取ったfromの属性を格納する変数
let fromName;
let fromDefvalue;

// 受け取ったtoの属性を格納する変数
let toName;
let toDefvalue;

const FromToTextBox = observer((props) => {
    const dispatch = useDispatch();

    const [fromValue, setFromValue] = useState('');
    const [toValue, setToValue] = useState('');
    useEffect(() => {
        if (stateStore.state[props.fromValue] != fromValue) {
            setFromValue(stateStore.state[props.fromValue]);
        }
    }, [stateStore.state[props.fromValue]])

    useEffect(() => {
        if (stateStore.state[props.toValue] != toValue) {
            setToValue(stateStore.state[props.toValue]);
        }
    }, [stateStore.state[props.toValue]])

    // 初回レンダリング時、fromtoに使用する値が不変の属性をchildrenから受け取る
    useEffect(() => {
        for (let child of props.children) {
            // from要素のidとdefvalueを受け取る
            if (!!child.props.fromto && child.props.fromto == "from") {
                fromName = child.props.name;
                if (!!child.props.defvalue) { fromDefvalue = child.props.defvalue; }
            }
            // to要素のidとdefvalueを受け取る
            if (!!child.props.fromto && child.props.fromto == "to") {
                toName = child.props.name;
                if (!!child.props.defvalue) { toDefvalue = child.props.defvalue; }
            }
        }
    }, [])

    // fromとtoの大小関係をチェックするuseEffect
    useEffect(() => {
        // フォーカス中の場合、チェックを行わない
        if (isFocus) {
            return;
        }
        // 親コンポーネントからfromとtoの値を取得する
        let fromValue = stateStore.state[props.fromValue];
        let toValue = stateStore.state[props.toValue];
        // fromValueまたはtoValueが未入力の場合、チェックを行わない
        if (!fromValue || !toValue) {
            //エラーメッセージ解除
            errMsgService.delMsgLabel(props);
            return;
        }
        // fromtoが日付の場合、fromとtoの値を日付から経過ミリ秒に変換する
        if (!!props.valueType && props.valueType == "date" && !!fromValue) {
            fromValue = new Date(fromValue).getTime();
        }
        if (!!props.valueType && props.valueType == "date" && !!toValue) {
            toValue = new Date(toValue).getTime();
        }
        // 大小関係をチェックする
        compare(fromValue, toValue);
    }, [stateStore.state[props.fromValue], stateStore.state[props.toValue]])

    // フォーカスインした時のイベント
    const onFocus = () => {
        // フォーカスフラグをtrueに更新
        isFocus = true;
    }

    // フォーカスアウトした時のイベント
    const onBlur = (event) => {
        // フォーカスフラグをfalseに更新
        isFocus = false;
        // to要素を未入力のままフォーカスアウトした時、from要素にdefvalue以外のvalueがあれば、to要素のvalueをその値で更新する
        if (event.target.name == toName && !stateStore.state[props.toValue] && !!stateStore.state[props.fromValue] && stateStore.state[props.fromValue] != fromDefvalue) {
            stateStore.setState(toName, stateStore.state[props.fromValue]);
            return;
        }
        // 親コンポーネントからfromとtoの値を取得する
        let fromValue = stateStore.state[props.fromValue];
        let toValue = stateStore.state[props.toValue];
        // fromValueまたはtoValueが未入力の場合、チェックを行わない
        if (!fromValue || !toValue) {
            //エラーメッセージ解除
            errMsgService.delMsgLabel(props);
            return;
        }
        // fromtoが日付の場合、fromとtoの値を日付から経過ミリ秒に変換する
        if (!!props.valueType && props.valueType == "date" && !!fromValue) {
            fromValue = new Date(fromValue).getTime();
        }
        if (!!props.valueType && props.valueType == "date" && !!toValue) {
            toValue = new Date(toValue).getTime();
        }
        // 大小関係をチェックする
        compare(fromValue, toValue);
    }

    /**
    * fromとtoの大小比較を行う
    * @param {*} fromValue 
    * @param {*} toValue 
    */
    const compare = (fromValue, toValue) => {
        // fromValue、toValueがどちらも数値型に変換できる場合、数値型に変換し比較する
        if (!isNaN(fromValue) && !isNaN(toValue)) {
            fromValue = Number(fromValue);
            toValue = Number(toValue);
        }
        if (fromValue > toValue) {
            errMsgService.addMsgLabel('ESYS0080', props);


        } else {
            //エラーメッセージ解除
            errMsgService.delMsgLabel(props);
        }
    }


    return (
        <div onBlur={onBlur} onFocus={onFocus} className={props.className}>
            {props.children}
        </div>
    );
});

export default FromToTextBox;
